import {Action} from '@ngrx/store';

import {Persona} from './personas.state';

export enum PersonasActionTypes {
  PERSONAS_LOAD_REQUEST = '[PERSONAS] Load Request',
  PERSONAS_LOAD_FAILURE = '[PERSONAS] Load Failure',
  PERSONAS_LOAD_SUCCESS = '[PERSONAS] Load Success',
  PERSONAS_REGISTRER_REDIRECT = '[PERSONAS] Registrer Redirect',
  PERSONAS_REGISTRER_FAILURE = '[PERSONAS] Registrer Failure',
  PERSONAS_REGISTRER_SUCCESS = '[PERSONAS] Registrer Success'
}

// load
export class PersonasLoadRequestAction implements Action {
  readonly type = PersonasActionTypes.PERSONAS_LOAD_REQUEST;
}

export class PersonasLoadFailureAction implements Action {
  readonly type = PersonasActionTypes.PERSONAS_LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class PersonasLoadSuccessAction implements Action {
  readonly type = PersonasActionTypes.PERSONAS_LOAD_SUCCESS;

  constructor(public payload: { items: Persona[] }) {
  }
}

// registrer in REUNE
export class PersonasRegistrerRedirectAction implements Action {
  readonly type = PersonasActionTypes.PERSONAS_REGISTRER_REDIRECT;
}

export class PersonasRegistrerFailureAction implements Action {
  readonly type = PersonasActionTypes.PERSONAS_REGISTRER_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class PersonasRegistrerSuccessAction implements Action {
  readonly type = PersonasActionTypes.PERSONAS_REGISTRER_SUCCESS;
}

// actions

export type PersonasActions =
  | PersonasLoadRequestAction
  | PersonasLoadFailureAction
  | PersonasLoadSuccessAction
  | PersonasRegistrerRedirectAction
  | PersonasRegistrerFailureAction
  | PersonasRegistrerSuccessAction;
